import React, { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { SolidCtaClickable } from '../../components/common/SolidCtaClickable';
import { appTheme, useThemeColors, type ThemeColors } from '../../shared/theme';
import { STACK_SCROLL_GUTTER, androidFlatSurfaceStyle } from '../../shared/theme/studio/stackScreenShell';
import { useTranslation } from '../../shared/i18n';
import { hexToRgba } from '../../shared/theme/colorUtils';

const FOOTER_BTN_HEIGHT = 48;
const FOOTER_VERTICAL_PAD = appTheme.spacing.md;

/** Extra FlatList `paddingBottom` so content clears the sticky guest back footer. */
export function guestBrowseBackFooterScrollPad(insets_bottom: number): number {
  return FOOTER_VERTICAL_PAD + FOOTER_BTN_HEIGHT + FOOTER_VERTICAL_PAD + Math.max(insets_bottom, appTheme.spacing.md);
}

type GuestBrowseBackFooterProps = {
  onBack: () => void;
};

export const GuestBrowseBackFooter = memo(function GuestBrowseBackFooter({ onBack }: GuestBrowseBackFooterProps) {
  const insets = useSafeAreaInsets();
  const colors = useThemeColors() ?? appTheme.colors;
  const { t } = useTranslation();
  const styles = useMemo(() => createStyles(colors), [colors]);

  return (
    <View style={[styles.footer, { paddingBottom: Math.max(insets.bottom, appTheme.spacing.md) }]}>
      <SolidCtaClickable label={t('main.goBackToMain')} onPress={onBack} variant="outline" size="compact" haptics />
    </View>
  );
});

function createStyles(c: ThemeColors) {
  return StyleSheet.create({
    footer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 101,
      paddingTop: FOOTER_VERTICAL_PAD,
      paddingHorizontal: STACK_SCROLL_GUTTER,
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: hexToRgba(c.text, 0.1),
      backgroundColor: c.surface,
      ...androidFlatSurfaceStyle(),
    },
  });
}
